export const OtherProjects = [
  {
    name: "Portfolio Website",
    description:
      "This portfolio is made using React.js , Tailwind CSS, React Icons and JS(ES-7).",
    link: "https://github.com/Kawaljeet2001/Portfolio",
  },
  {
    name: "Live Covid-19 Cases Tracker",
    description:
      "The website helps you track Covid-19 stats all around the world and all Indian states.",
    link: "https://github.com/Kawaljeet2001/Live-Covid-19Tracker",
  },
  {
    name: "IPL First Innings Score Prediction",
    description:
      "This project uses machine learning regression approach to predict the first inning score of an IPL match, based on previous year cricket matches.",
    link: "https://github.com/Kawaljeet2001/IPL-First-Innings-Score-Prediction",
  },
  {
    name: "Micro-Blogging Platform",
    description:
      "BLOG MASTER is a blogging platform that lets its user to Create , Edit , Publish and share their blogs.",
    link: "https://github.com/Kawaljeet2001/IPL-First-Innings-Score-Prediction",
  },
  {
    name: "React - Firebase Todo List App",
    description:
      "This is a minimalistic Todo Home made using React Hooks, Firebase Firestore, and Material Ui.",
    link: "https://github.com/Kawaljeet2001/React-Firebase-TodoApp",
  },
];
